export default __webpack_public_path__ + "static/assets/be75af85f41e520a62d0b7167ac1cb36.png";